import aceRatingUrl from '~/boggle/assets/ace.png'
import bronzeRatingUrl from '~/boggle/assets/bronze.png'
import diamondRatingUrl from '~/boggle/assets/diamond.png'
import goldRatingUrl from '~/boggle/assets/gold.png'
import silverRatingUrl from '~/boggle/assets/silver.png'
import type { BoggleRunSummaryRatingId } from '~/boggle/config/runSummaryScore'

/** Shared rating-badge artwork; `none` intentionally has no image. */
export const BOGGLE_RATING_BADGE_IMAGES: Partial<
  Record<BoggleRunSummaryRatingId, string>
> = {
  ace: aceRatingUrl,
  bronze: bronzeRatingUrl,
  diamond: diamondRatingUrl,
  gold: goldRatingUrl,
  silver: silverRatingUrl,
}
